import React, { Component } from 'react';
import { Button, Card, Tab, Tabs, Modal, Form } from 'react-bootstrap';
import {
    TextField,
    Autocomplete,
    MenuItem,
    InputAdornment,
    IconButton,
    Chip,
    Box,
    Select,
    FormControl,
    InputLabel
} from '@mui/material';
import { AgChartsReact } from 'ag-charts-react';
import {
    updateQcSample,
    createQcSample,
    getQcSampleDataById,
    searchQcSamples,
    fetchQcSamples
} from '../../../../services/clinicPortalServices/qcSampleService.js';
import {
    createQcReport,
    getQcReportDataById,
    getRecentQcReports,
    updateQcReport
} from '../../../../services/clinicPortalServices/qcReportService.js';
import { getAllAnalytes } from '../../../../services/clinicPortalServices/analyteService.js';
import { fetchQcRanges, searchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService.js';
import { fetchInstruments } from '../../../../services/clinicPortalServices/instrumentService.js';
import { getUserFullName } from '../../../../services/common/util.js';
import moment from 'moment';
import { MobileDatePicker } from '@mui/x-date-pickers';
import EventIcon from '@mui/icons-material/Event';
import { qcControlTypes } from '../../../../services/common/optionsData.js';
import toastr from 'toastr';
import {
    searchQcResults,
    searchQcResultsForReport
} from '../../../../services/clinicPortalServices/qcResultService.js';

const ALL_CONTROL_TYPES_ID = 'allControlTypes';
const ALL_CONTROL_TYPES_LABEL = 'All Types';

const ALL_LOT_NUMBERS_ID = 'allLotNumbers';
const ALL_LOT_NUMBERS_LABEL = 'All Active Lots';

const ALL_SAMPLES_ID = 'allSamples';
const ALL_SAMPLES_LABEL = 'All Samples';

const ALL_INSTRUMENTS_ID = 'allInstruments';
const ALL_INSTRUMENTS_LABEL = 'All Instruments';

export default class QcReportDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qcReportId: this.props.qcReportId || null,
            recentReports: [],
            analyte: '',
            controlType: '',
            lotNumber: '',
            qcSampleId: '',
            sampleStatus: 'all', // Active Only, All, Expired
            resultStatus: 'all', // All Results, Pass Only, Fail Only, In Range, Out of Range
            instrument: ALL_INSTRUMENTS_ID,
            fromDate: moment().subtract(1, 'month'),
            toDate: moment(),
            displayMode: 'onePerLot',

            // View Mode
            activeTab: 'chart',
            viewMode: 'chart',

            // Data
            analytes: [],
            qcRanges: [],
            JenningsChartData: [],
            controlTypes: [],
            lotNumbers: [],
            qcSamples: [],
            instruments: [],

            // Chart/Grid Data
            chartData: [],
            gridData: [],

            // Save Report Modal
            showSaveModal: false,
            isFirstLoading: true,
            reportName: '',
            errors: []
        };
    }

    componentDidMount() {
        this.loadInitialData();
    }
    
    leveyJenningsChartData = (data) => {
        const { qcRanges } = this.state;                      
        const qcMap = {};
        qcRanges.forEach(qc => {
            const key = `${qc.analyteId?._id || qc.analyteId}_${qc.controlType}`;
            qcMap[key] = qc;
        });

        const chartData = data.map(item => {
            const analyteId = item.analyte_id?._id || item.analyte_id;
            const controlType = item.qc_sample_id?.controlType || '';
            const qcKey = `${analyteId}_${controlType}`;
            const qcInfo = qcMap[qcKey] || {};
            const currentdate = moment(item.createdAt).format('MM/DD/YYYY');
            

            const target = Number(qcInfo.targetValue) || 0;
            const value = Number(item.value) || 0;
            const sd = Number(qcInfo.sdValue) || 0;           
            return {
                name: item.analyte_id?.name || 'Unknown',
                lotNumber: item.qc_sample_id?.lotNumber || 'Unknown',
                analyteId,
                controlType,
                createdAt: moment(item.createdAt).format('MM/DD/YYYY HH:mm'),
                value,
                target ,
                sdValue: sd || 0,
                sd1Upper: target + sd,
                sd1Lower: target - sd,
                sd2Upper: target + 2 * sd,
                sd2Lower: target - 2 * sd,
                pass: Math.abs(value - target) <= sd,
            };
        });

        return chartData;
    };


    loadInitialData = async () => {
        try {
            if (this.state.qcReportId) {
                // Load recent reports
                getQcReportDataById(this.state.qcReportId).then((res) => {
                    if (res && res.data) {
                        this.setState(
                            {
                                reportName: res.data.name || '',
                                analyte: res.data.analyte ? res.data.analyte : null,
                                controlType: res.data.controlType ? res.data.controlType : null,
                                lotNumber: res.data.lotNumber ? res.data.lotNumber : null,
                                sampleStatus: res.data.sampleStatus ? res.data.sampleStatus : 'all',
                                resultStatus: res.data.resultStatus ? res.data.resultStatus : 'all',
                                qcSampleId: res.data.qcSample?.isAll
                                    ? ALL_SAMPLES_ID
                                    : res.data.qcSample?.selectedItem
                                    ? res.data.qcSample.selectedItem._id
                                    : '',
                                instrument: res.data.instrument?.isAll
                                    ? ALL_INSTRUMENTS_ID
                                    : res.data.instrument?.selectedItem
                                    ? res.data.instrument.selectedItem._id
                                    : ALL_INSTRUMENTS_ID,
                                fromDate: res.data.fromDate
                                    ? moment(res.data.fromDate, 'YYYY-MM-DD')
                                    : moment().subtract(1, 'month'),
                                toDate: res.data.toDate ? moment(res.data.toDate, 'YYYY-MM-DD') : moment(),
                                displayMode: res.data.displayMode ? res.data.displayMode : 'onePerLot',
                                viewMode: res.data.viewMode ? res.data.viewMode : 'chart'
                            },
                            () => {
                                this.loadControlTypesForAnalyte(this.state.analyte._id);
                                this.loadLotsForControlType(this.state.analyte._id, this.state.controlType);
                                this.loadQcSamplesForLot(
                                    this.state.analyte._id,
                                    this.state.controlType,
                                    this.state.lotNumber
                                );
                            }
                        );
                    }
                });
            }
            // Load recent reports
            getRecentQcReports().then((recentReportsRes) => {
                if (recentReportsRes && recentReportsRes.data) {
                    this.setState({ recentReports: recentReportsRes.data });
                }
            });

            // Load analytes
            getAllAnalytes().then((analytesRes) => {
                if (analytesRes && analytesRes.data) {
                    this.setState({ analytes: analytesRes.data });
                }
            });
            // Load QC ranges
            fetchQcRanges().then((qcRangesRes) => {
                if (qcRangesRes && qcRangesRes.data) {                    
                    this.setState({ qcRanges: qcRangesRes.data });
                }
            });

            // Load instruments
            fetchInstruments().then((instrumentsRes) => {
                if (instrumentsRes && instrumentsRes.data) {
                    this.setState({
                        instruments: [{ _id: ALL_INSTRUMENTS_ID, name: ALL_INSTRUMENTS_LABEL }, ...instrumentsRes.data]
                    });
                }
            });
        } catch (error) {
            console.error('Error loading initial data:', error);
        }
    };

    handleAnalyteChange = (event, newValue) => {
        this.setState({
            analyte: newValue,
            controlType: null,
            lotNumber: null,
            qcSampleId: ''
        });
        if (newValue) {
            this.loadControlTypesForAnalyte(newValue._id);
        }
    };

    loadControlTypesForAnalyte = async (analyteId) => {
        let controlTypes = [];
        if (analyteId) {
            const rangesResponse = await searchQcRanges({ analyteId });
            if (rangesResponse?.data.length) {
                controlTypes = [
                    {
                        _id: ALL_CONTROL_TYPES_ID,
                        name: ALL_CONTROL_TYPES_LABEL
                    },
                    ...[...new Set(rangesResponse.data.map((item) => item.controlType))].map((item) => ({
                        _id: item,
                        name: item
                    }))
                ];
            }
        }
        this.setState({ controlTypes });
    };

    handleControlTypeChange = (e) => {
        const controlType = e.target.value;
        this.setState({
            controlType,
            lotNumber: null,
            qcSampleId: ''
        });
        if (controlType && this.state.analyte) {
            this.loadLotsForControlType(this.state.analyte._id, controlType);
        }
    };

    loadLotsForControlType = async (analyteId, controlType) => {
        try {
            let filter = {},
                lotNumbers = [];
            if (analyteId) filter.analyteIds = analyteId;
            if (controlType && controlType !== ALL_CONTROL_TYPES_ID) filter.controlType = controlType;

            const samplesRes = await searchQcSamples(filter);
            if (samplesRes.data.length) {
                lotNumbers = [
                    { _id: ALL_LOT_NUMBERS_ID, name: ALL_LOT_NUMBERS_LABEL },
                    ...[...new Set(samplesRes.data.map((item) => item.lotNumber))].map((item) => ({
                        _id: item,
                        name: item
                    }))
                ];
            }
            this.setState({ lotNumbers });
        } catch (error) {
            console.error('Error loading lots:', error);
        }
    };

    handleLotNumberChange = (e) => {
        const lotNumber = e.target.value;
        this.setState({
            lotNumber,
            qcSampleId: ''
        });
        if (lotNumber && this.state.analyte && this.state.controlType) {
            this.loadQcSamplesForLot(this.state.analyte._id, this.state.controlType, lotNumber);
        }
    };

    loadQcSamplesForLot = async (analyteId, controlType, lotNumber) => {
        try {
            let filter = {};
            if (analyteId) filter.analyteId = analyteId;
            if (controlType && controlType !== ALL_CONTROL_TYPES_ID) filter.controlType = controlType;
            if (lotNumber && lotNumber !== ALL_LOT_NUMBERS_ID) filter.lotNumber = lotNumber;

            const samplesRes = await searchQcSamples(filter);
            if (samplesRes && samplesRes.data?.length) {
                this.setState(
                    {
                        qcSamples: [
                            { _id: ALL_SAMPLES_ID, name: `${ALL_SAMPLES_LABEL} for ${this.state.analyte.name}` },
                            ...samplesRes.data
                        ]
                    },
                    () => {
                        if (this.state.isFirstLoading && this.state.qcReportId) {
                            this.generateReport();
                        }
                        this.setState({ isFirstLoading: false });
                    }
                );
            } else {
                this.setState({ qcSamples: [] });
            }
        } catch (error) {
            console.error('Error loading QC samples:', error);
        }
    };

    handleDateRangeChange = (type) => {
        let fromDate, toDate;
        const today = moment();

        switch (type) {
            case 'today':
                fromDate = today.clone();
                toDate = today.clone();
                break;
            case 'week':
                fromDate = today.clone().subtract(7, 'days');
                toDate = today.clone();
                break;
            case 'month':
                fromDate = today.clone().subtract(1, 'month');
                toDate = today.clone();
                break;
            case 'quarter':
                fromDate = today.clone().subtract(3, 'months');
                toDate = today.clone();
                break;
            default:
                return;
        }

        this.setState({ fromDate, toDate });
    };

    handleFilterChange = (field, value) => {
        let processedValue = value;

        switch (field) {
            case 'fromDate':
            case 'toDate':
                processedValue = moment(value.$d);
                break;
            default:
                break;
        }

        this.setState({ [field]: processedValue });
    };

    generateReport = async () => {
        try {
            let filters = { sampleStatus: this.state.sampleStatus, resultStatus: this.state.resultStatus };
            if (this.state.analyte?._id) filters.analyte_id = this.state.analyte._id;
            if (this.state.qcSampleId && this.state.qcSampleId !== ALL_SAMPLES_ID)
                filters.qc_sample_id = this.state.qcSampleId;
            else if (this.state.qcSampleId === ALL_SAMPLES_ID) {
                filters.qc_sample_id = { $in: this.state.qcSamples.slice(1).map((sample) => sample._id) };
            }
            if (this.state.instrument && this.state.instrument !== ALL_INSTRUMENTS_ID) {
                filters.instrument_id = this.state.instrument;
            }
            const toDateString = this.state.toDate.format('YYYY-MM-DD');
            const toDateNextDate = moment(toDateString, 'YYYY-MM-DD').add(1, 'day');
            filters.createdAt = {
                $gte: this.state.fromDate.utc(),
                $lt: toDateNextDate.utc()
            };

            const dataRes = await searchQcResultsForReport(filters);
            if (dataRes && dataRes.data) {                
                this.setState({
                    chartData: dataRes.data,
                    gridData: dataRes.data,
                    JenningsChartData: this.leveyJenningsChartData(dataRes.data)
                });
                if (dataRes.data.length === 0) {
                    toastr.info('No data found for the selected filters.');
                }
            } else {
                toastr.error('Error loading report data.');
            }
        } catch (error) {
            console.error('Error loading report data:', error);
        }
    };

    prepareChartData = () => {
        const { chartData, displayMode } = this.state;

        if (!chartData || chartData.length === 0) {
            return [];
        }

        // Transform data for chart with proper date formatting
        const transformedData = chartData.map((item) => ({
            ...item,
            createdAtFormatted: moment(item.createdAt).format('MM/DD/YYYY HH:mm'),
            createdAtTimestamp: moment(item.createdAt).valueOf(),
            lotNumber: item.qc_sample_id?.lotNumber || 'Unknown',
            value: parseFloat(item.value) || 0
        }));

        switch (displayMode) {
            case 'onePerLot':
                return this.groupByLot(transformedData);
            case 'allLotsCombined':
                return transformedData;
            case 'compareLots':
                return this.prepareCompareLotsData(transformedData);
            default:
                return transformedData;
        }
    };

    groupByLot = (data) => {
        const lotGroups = {};
        data.forEach((item) => {
            const lot = item.lotNumber;
            if (!lotGroups[lot]) {
                lotGroups[lot] = [];
            }
            lotGroups[lot].push(item);
        });
        return lotGroups;
    };

    prepareCompareLotsData = (data) => {
        // For side-by-side comparison, we'll group data by lot number
        // and create series for each lot
        return this.groupByLot(data);
    };

    getChartOptions = () => {
        const chartData = this.prepareChartData();
        const { displayMode } = this.state;

        if (displayMode === 'onePerLot') {
            // Return options for multiple charts (one per lot)
            return this.getOnePerLotChartOptions(chartData);
        } else if (displayMode === 'allLotsCombined') {
            // Single chart with all data
            return this.getAllLotsCombinedChartOptions(chartData);
        } else if (displayMode === 'compareLots') {
            // Single chart with series for each lot
            return this.getCompareLotsChartOptions(chartData);
        }

        return null;
    };

    getAllLotsCombinedChartOptions = (data) => {
        const referenceLines = this.getQcReferenceLines(data);

        return {
            data: data,
            series: [
                {
                    type: 'line',
                    xKey: 'createdAtTimestamp',
                    yKey: 'value',
                    title: 'QC Values',
                    marker: {
                        enabled: true
                    }
                }
            ],
            axes: [
                {
                    type: 'time',
                    position: 'bottom',
                    title: {
                        text: 'Date/Time'
                    },
                    label: {
                        format: '%m/%d/%Y'
                    }
                },
                {
                    type: 'number',
                    position: 'left',
                    title: {
                        text: 'Value'
                    },
                    crossLines: referenceLines
                }
            ],
            title: {
                text: ''
            },
            legend: {
                enabled: true
            }
        };
    };

    getCompareLotsChartOptions = (lotGroups) => {
        // Get reference lines from the first lot's data
        const firstLotData = Object.values(lotGroups)[0] || [];
        const referenceLines = this.getQcReferenceLines(firstLotData);

        const series = Object.keys(lotGroups).map((lotNumber) => ({
            type: 'line',
            xKey: 'createdAtTimestamp',
            yKey: 'value',
            title: `Lot ${lotNumber}`,
            data: lotGroups[lotNumber],
            marker: {
                enabled: true
            }
        }));

        return {
            series: series,
            axes: [
                {
                    type: 'time',
                    position: 'bottom',
                    title: {
                        text: 'Date/Time'
                    },
                    label: {
                        format: '%m/%d/%Y'
                    }
                },
                {
                    type: 'number',
                    position: 'left',
                    title: {
                        text: 'Value'
                    },
                    crossLines: referenceLines
                }
            ],
            title: {
                text: ''
            },
            legend: {
                enabled: true
            }
        };
    };

    getOnePerLotChartOptions = (lotGroups) => {
        return Object.keys(lotGroups).map((lotNumber) => {
            const lotData = lotGroups[lotNumber];
            const referenceLines = this.getQcReferenceLines(lotData);

            const chartOptions = {
                data: lotData,
                series: [
                    {
                        type: 'line',
                        xKey: 'createdAtTimestamp',
                        yKey: 'value',
                        title: `Lot ${lotNumber}`,
                        marker: {
                            enabled: true
                        }
                    }
                ],
                axes: [
                    {
                        type: 'time',
                        position: 'bottom',
                        title: {
                            text: 'Date/Time'
                        },
                        label: {
                            format: '%m/%d/%Y'
                        }
                    },
                    {
                        type: 'number',
                        position: 'left',
                        title: {
                            text: 'Value'
                        }
                    }
                ],
                title: {
                    text: ''
                },
                legend: {
                    enabled: false
                }
            };

            // Add crossLines if we have reference lines
            if (referenceLines && referenceLines.length > 0) {
                chartOptions.axes[1].crossLines = referenceLines;
            }
            return chartOptions;
        });
    };

    handleSaveReport = () => {
        if (!this.state.analyte) {
            toastr.error('Please select an analyte to save the report.');
            return;
        }
        this.setState({ showSaveModal: true });
    };

    handleCloseSaveModal = () => {
        this.setState({
            showSaveModal: false,
            reportName: ''
        });
    };

    handleReportNameChange = (e) => {
        this.setState({ reportName: e.target.value });
    };

    handleConfirmSaveReport = async () => {
        const { reportName } = this.state;

        if (!reportName.trim()) {
            toastr.error('Please enter a report name.');
            return;
        }

        try {
            const reportData = {
                name: reportName.trim(),
                analyte: this.state.analyte?._id || null,
                controlType: this.state.controlType,
                lotNumber: this.state.lotNumber,
                qcSample:
                    this.state.qcSampleId === ALL_SAMPLES_ID
                        ? {
                              isAll: true,
                              selectedItem: null
                          }
                        : {
                              isAll: false,
                              selectedItem: this.state.qcSampleId ? this.state.qcSampleId : null
                          },
                instrument:
                    this.state.instrument === ALL_INSTRUMENTS_ID
                        ? {
                              isAll: true,
                              selectedItem: null
                          }
                        : {
                              isAll: false,
                              selectedItem: this.state.instrument ? this.state.instrument : null
                          },
                fromDate: this.state.fromDate ? this.state.fromDate.format('YYYY-MM-DD') : '',
                toDate: this.state.toDate ? this.state.toDate.format('YYYY-MM-DD') : '',
                displayMode: this.state.displayMode,
                viewMode: this.state.viewMode,
                sampleStatus: this.state.sampleStatus,
                resultStatus: this.state.resultStatus
            };

            if (this.state.qcReportId) {
                const updateResponse = await updateQcReport({ _id: this.state.qcReportId, ...reportData });
                if (updateResponse) {
                    if (updateResponse.data && updateResponse.data._id) {
                        this.setState({ qcReportId: updateResponse.data._id, showSaveModal: false });
                        toastr.success('Report updated successfully!');
                    } else {
                        toastr.error(updateResponse.message || 'Error updating report.');
                    }
                } else {
                    toastr.error('Error updating report. Please try again.');
                }
            } else {
                const createResponse = await createQcReport(reportData);
                if (createResponse) {
                    if (createResponse.data && createResponse.data._id) {
                        this.setState({ qcReportId: createResponse.data._id, showSaveModal: false });
                        toastr.success('Report created successfully!');
                    } else {
                        toastr.error(createResponse.message || 'Error creating report.');
                    }
                } else {
                    toastr.error('Error creating report. Please try again.');
                }
            }

            // Convert to JSON and download
            // const dataStr = JSON.stringify(reportData, null, 2);
            // const dataBlob = new Blob([dataStr], { type: 'application/json' });
            // const url = URL.createObjectURL(dataBlob);
            // const link = document.createElement('a');
            // link.href = url;
            // link.download = `${reportName.trim()}_${moment().format('YYYY-MM-DD')}.json`;
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // URL.revokeObjectURL(url);

            // toastr.success('Report saved successfully!');
            // this.handleCloseSaveModal();
        } catch (error) {
            console.error('Error saving report:', error);
            toastr.error('Error saving report. Please try again.');
        }
    };

    handlePrintReport = () => {
        window.print();
    };

    handleRecentReportClick = (report) => {
        // Close current modal if open
        this.setState({ showSaveModal: false });

        // Navigate to the selected report
        if (report._id) {
            // You can either navigate to a new page or load the report data
            // Option 1: Navigate to report detail page
            // window.location.href = `/reports/${report._id}`;

            // Option 2: Load report data in current component
            this.loadReportById(report._id);
        }
    };

    loadReportById = async (reportId) => {
        try {
            const response = await getQcReportDataById(reportId);
            if (response && response.data) {
                const reportData = response.data;

                // Update state with the loaded report data
                this.setState(
                    {
                        qcReportId: reportData._id,
                        reportName: reportData.name || '',
                        analyte: reportData.analyte || null,
                        controlType: reportData.controlType || null,
                        lotNumber: reportData.lotNumber || null,
                        qcSampleId: reportData.qcSample?.isAll
                            ? ALL_SAMPLES_ID
                            : reportData.qcSample?.selectedItem
                            ? reportData.qcSample.selectedItem._id
                            : '',
                        instrument: reportData.instrument?.isAll
                            ? ALL_INSTRUMENTS_ID
                            : reportData.instrument?.selectedItem
                            ? reportData.instrument.selectedItem._id
                            : ALL_INSTRUMENTS_ID,
                        fromDate: reportData.fromDate ? moment(reportData.fromDate) : moment().subtract(1, 'month'),
                        toDate: reportData.toDate ? moment(reportData.toDate) : moment(),
                        displayMode: reportData.displayMode || 'onePerLot',
                        viewMode: reportData.viewMode || 'chart',
                        activeTab: reportData.viewMode || 'chart',
                        sampleStatus: reportData.sampleStatus || 'all',
                        resultStatus: reportData.resultStatus || 'all'
                    },
                    () => {
                        // Load dependent data and generate report
                        if (this.state.analyte) {
                            this.loadControlTypesForAnalyte(this.state.analyte._id);
                            if (this.state.controlType) {
                                this.loadLotsForControlType(this.state.analyte._id, this.state.controlType);
                                if (this.state.lotNumber) {
                                    this.loadQcSamplesForLot(
                                        this.state.analyte._id,
                                        this.state.controlType,
                                        this.state.lotNumber
                                    );
                                }
                            }
                        }
                        // Generate report with loaded data
                        this.generateReport();
                    }
                );

                toastr.success(`Loaded report: ${reportData.name}`);
            }
        } catch (error) {
            console.error('Error loading report:', error);
            toastr.error('Error loading report. Please try again.');
        }
    };

    renderRecentReports = () => {
        return (
            <div className="mb-4">
                {this.state.recentReports.length > 0 && (
                    <div>
                        <h4 className="mb-3">Recent QC Reports</h4>
                        <div className="row">
                            {this.state.recentReports.slice(0, 3).map((report, index) => (
                                <div key={index} className="col-md-4 mb-3">
                                    <Card
                                        style={{
                                            cursor: 'pointer',
                                            transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                        }}
                                        onClick={() => this.handleRecentReportClick(report)}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
                                        }}
                                    >
                                        <Card.Body>
                                            <Card.Title style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                                {report.name} from {moment(report.fromDate).format('MM/DD/YYYY')}-
                                                {moment(report.toDate).format('MM/DD/YYYY')}
                                            </Card.Title>
                                            <Card.Text style={{ fontSize: '12px', color: '#666' }}>
                                                {report.analyte?.name} • {moment(report.createdAt).format('MM/DD/YYYY')}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    renderFilters = () => {
        const displayModeOptions = [
            { value: 'onePerLot', label: 'One Chart per Lot' },
            { value: 'allLotsCombined', label: 'All Lots Combined' },
            { value: 'compareLots', label: 'Compare Lots Side-by-Side' }
        ];

        return (
            <div className="mb-4">
                <div className="row">
                    {/* Analyte Filter */}
                    <div className="col-md-6 col-lg-3 mb-3">
                        <Autocomplete
                            value={this.state.analyte}
                            options={this.state.analytes}
                            getOptionLabel={(option) => option?.name || ''}
                            onChange={this.handleAnalyteChange}
                            renderInput={(params) => <TextField {...params} label="Analyte *" variant="outlined" />}
                        />
                    </div>

                    {/* Control Type Filter */}
                    <div className="col-md-6 col-lg-3 mb-3">
                        <FormControl variant="outlined" style={{ width: '100%' }}>
                            <InputLabel>Control Type *</InputLabel>
                            <Select
                                label="Control Type *"
                                select
                                value={this.state.controlType}
                                onChange={this.handleControlTypeChange}
                                variant="outlined"
                                fullWidth
                                disabled={!this.state.analyte}
                            >
                                {this.state.controlTypes.map((type) => (
                                    <MenuItem key={type._id} value={type._id}>
                                        {type.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    {/* Lot Number Filter */}
                    <div className="col-md-6 col-lg-3 mb-3">
                        <FormControl variant="outlined" style={{ width: '100%' }}>
                            <InputLabel>Lot Number *</InputLabel>
                            <Select
                                label="Lot Number *"
                                select
                                value={this.state.lotNumber}
                                onChange={this.handleLotNumberChange}
                                variant="outlined"
                                fullWidth
                                disabled={!this.state.controlType}
                            >
                                {this.state.lotNumbers.map((lot) => (
                                    <MenuItem key={lot._id} value={lot._id}>
                                        {lot.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    {/* QC Sample ID Filter */}
                    <div className="col-md-6 col-lg-3 mb-3">
                        <FormControl variant="outlined" style={{ width: '100%' }}>
                            <InputLabel>QC Sample ID *</InputLabel>
                            <Select
                                label="QC Sample ID *"
                                select
                                value={this.state.qcSampleId}
                                onChange={(e) => this.handleFilterChange('qcSampleId', e.target.value)}
                                variant="outlined"
                                fullWidth
                                disabled={!this.state.lotNumber}
                            >
                                {this.state.qcSamples.map((sample) => (
                                    <MenuItem key={sample._id} value={sample._id}>
                                        {sample.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    {/* Sample Status Filter */}
                    <div className="col-md-6 col-lg-4 mb-3">
                        <FormControl variant="outlined" style={{ width: '100%' }}>
                            <InputLabel>Sample Status</InputLabel>
                            <Select
                                label="Sample Status"
                                select
                                value={this.state.sampleStatus}
                                onChange={(e) => this.handleFilterChange('sampleStatus', e.target.value)}
                                variant="outlined"
                                fullWidth
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="active">Active Only</MenuItem>
                                <MenuItem value="expired">Expired</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    {/* Result Status Filter */}
                    <div className="col-md-6 col-lg-4 mb-3">
                        <FormControl variant="outlined" style={{ width: '100%' }}>
                            <InputLabel>Result Status</InputLabel>
                            <Select
                                label="Result Status"
                                select
                                value={this.state.resultStatus}
                                onChange={(e) => this.handleFilterChange('resultStatus', e.target.value)}
                                variant="outlined"
                                fullWidth
                            >
                                <MenuItem value="all">All Results</MenuItem>
                                <MenuItem value="pass">Pass Only</MenuItem>
                                <MenuItem value="fail">Fail Only</MenuItem>
                                {/* <MenuItem value="inRange">In Range</MenuItem>
                                <MenuItem value="outOfRange">Out of Range</MenuItem> */}
                            </Select>
                        </FormControl>
                    </div>

                    {/* Instrument Filter */}
                    <div className="col-md-6 col-lg-4 mb-3">
                        <FormControl variant="outlined" style={{ width: '100%' }}>
                            <InputLabel>Instrument</InputLabel>
                            <Select
                                label="Instrument"
                                select
                                value={this.state.instrument}
                                onChange={(e) => this.handleFilterChange('instrument', e.target.value)}
                                variant="outlined"
                                fullWidth
                            >
                                {this.state.instruments.map((instrument) => (
                                    <MenuItem key={instrument._id} value={instrument._id}>
                                        {instrument.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>

                {/* Date Range Filters */}
                <div className="row mb-3">
                    <div className="col-12">
                        <div className="me-3">Date Range</div>

                        <div className="d-flex align-items-center my-1 gap-2">
                            <Button
                                variant="info"
                                className="mr-2 dateRangeBtn"
                                onClick={() => this.handleDateRangeChange('today')}
                            >
                                Today
                            </Button>
                            <Button
                                variant="info dateRangeBtn"
                                className="mr-2"
                                onClick={() => this.handleDateRangeChange('week')}
                            >
                                Week
                            </Button>
                            <Button
                                variant="info dateRangeBtn"
                                className="mr-2"
                                onClick={() => this.handleDateRangeChange('month')}
                            >
                                Month
                            </Button>
                            <Button
                                variant="info dateRangeBtn"
                                className=""
                                onClick={() => this.handleDateRangeChange('quarter')}
                            >
                                Quarter
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6 col-lg-4 mb-3">
                        <MobileDatePicker
                            value={this.state.fromDate}
                            onChange={(date) => this.handleFilterChange('fromDate', date)}
                            label="From Date"
                            renderInput={(props) => (
                                <TextField
                                    {...props}
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end">
                                                    <EventIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div className="col-md-6 col-lg-4 mb-3">
                        <MobileDatePicker
                            value={this.state.toDate}
                            onChange={(date) => this.handleFilterChange('toDate', date)}
                            label="To Date"
                            renderInput={(props) => (
                                <TextField
                                    {...props}
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end">
                                                    <EventIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>

                <div className="row">
                    {/* Display Mode Filter */}
                    <div className="col-12 mb-3">
                        <TextField
                            label="Display Mode"
                            select
                            value={this.state.displayMode}
                            onChange={(e) => this.handleFilterChange('displayMode', e.target.value)}
                            variant="outlined"
                            fullWidth
                        >
                            {displayModeOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                        <Button
                            variant="primary"
                            onClick={this.generateReport}
                            style={{ height: '40px' }}
                            disabled={
                                !this.state.analyte ||
                                !this.state.controlType ||
                                !this.state.lotNumber ||
                                !this.state.qcSampleId
                            }
                        >
                            Generate Report
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    getControlTypes = (options) => {
        const controlTypes = options.data.map((series) => series.qc_sample_id.controlType + ' QC Control');
        const uniqueControlTypes = [...new Set(controlTypes)];

        return uniqueControlTypes.join(', ');
    };

    getChartSubTitle = (options) => {
        let chartSubTitles = [];
        let targetValueString = '';
        const targetValues = options.data.map((series) => series.targetValue);
        const uniqueTargetValues = [...new Set(targetValues)];
        if (uniqueTargetValues.length === 1) {
            const targetValue = Number(uniqueTargetValues[0]);
            const analyteUnit = this.state.analyte?.units || 'N/A';
            const targetOffset = targetValue / 10;
            const maxOffset = targetValue / 20;
            targetValueString = 'Target: ' + targetValue + ' ' + analyteUnit + ' ± ' + targetOffset;
            chartSubTitles.push(targetValueString);
        }

        const lotNumber = options.data[0].lotNumber || '';
        if (lotNumber) chartSubTitles.push('QC Lot: ' + lotNumber);

        const lotExpirationDate = options.data[0].qc_sample_id?.lotExpirationDate || '';
        if (lotExpirationDate)
            chartSubTitles.push(
                lotExpirationDate ? 'Exp: ' + moment(lotExpirationDate, 'YYYYMMDD').format('MM/DD/YYYY') : ''
            );
        return chartSubTitles.join(' | ');
    };

    getQcReferenceLines = (data) => {
        if (!data || data.length === 0) return [];

        const targetValues = data.map((series) => series.targetValue);
        const uniqueTargetValues = [...new Set(targetValues.filter((val) => val !== null && val !== undefined))];

        if (uniqueTargetValues.length !== 1) return [];

        const targetValue = Number(uniqueTargetValues[0]);
        const targetOffset = targetValue / 10;
        const maxOffset = targetValue / 20;

        return [
            // Target value line (green)
            {
                type: 'line',
                value: targetValue,
                stroke: '#28a745',
                strokeWidth: 2,
                strokeDashArray: [5, 5],
                label: {
                    text: `Target: ${targetValue}`,
                    position: 'topRight'
                }
            },
            // Upper target offset line (blue)
            {
                type: 'line',
                value: targetValue + targetOffset,
                stroke: '#007bff',
                strokeWidth: 1.5,
                strokeDashArray: [3, 3],
                label: {
                    text: `+${targetOffset.toFixed(1)}`,
                    position: 'topRight'
                }
            },
            // Lower target offset line (blue)
            {
                type: 'line',
                value: targetValue - targetOffset,
                stroke: '#007bff',
                strokeWidth: 1.5,
                strokeDashArray: [3, 3],
                label: {
                    text: `-${targetOffset.toFixed(1)}`,
                    position: 'topRight'
                }
            },
            // Upper max offset line (red)
            {
                type: 'line',
                value: targetValue + maxOffset,
                stroke: '#dc3545',
                strokeWidth: 1,
                strokeDashArray: [2, 2],
                label: {
                    text: `+${maxOffset.toFixed(1)}`,
                    position: 'topRight'
                }
            },
            // Lower max offset line (red)
            {
                type: 'line',
                value: targetValue - maxOffset,
                stroke: '#dc3545',
                strokeWidth: 1,
                strokeDashArray: [2, 2],
                label: {
                    text: `-${maxOffset.toFixed(1)}`,
                    position: 'topRight'
                }
            }
        ];
    };
    
renderLeveyJenningsChart = () => {
    const { JenningsChartData, displayMode } = this.state;

    if (!JenningsChartData || JenningsChartData.length === 0) {
        return (
            <div className="text-center py-4">
                <p>No data available for Levey-Jennings chart.</p>
            </div>
        );
    }

    // ✅ Group data by both Lot and Control Type with clean normalization
    const groupedData = JenningsChartData.reduce((acc, item) => {
        const lot = item.name || "Unknown Lot";
        const control = item.controlType || "Unknown Control";
        const key = `${lot}__${control}`;

        const clean = (v) =>
            v === null || v === undefined || v === "" || isNaN(Number(v))
                ? null
                : Number(v);

        // ✅ Safe date parsing for formats like "09/16/2025 19:29"
        const parsedDate = (() => {
            if (typeof item.createdAt === "string") {
                const parts = item.createdAt.split(/[\/\s:]/); // ["09","16","2025","19","29"]
                if (parts.length >= 5) {
                    const [mm, dd, yyyy, hh, min] = parts.map(Number);
                    return new Date(yyyy, mm - 1, dd, hh, min);
                }
            }
            return new Date(item.createdAt || item.createdAtTimestamp);
        })();

        const cleanItem = {
            ...item,
            value: clean(item.value),
            target: clean(item.target),
            sd1Upper: clean(item.sd1Upper),
            sd1Lower: clean(item.sd1Lower),
            sd2Upper: clean(item.sd2Upper),
            sd2Lower: clean(item.sd2Lower),
            createdAt: parsedDate,            
        };

        // ✅ Determine fail condition (outside ±2SD)
        cleanItem.isFail =
            cleanItem.value !== null &&
            cleanItem.sd2Upper !== null &&
            cleanItem.sd2Lower !== null &&
            (cleanItem.value > cleanItem.sd2Upper || cleanItem.value < cleanItem.sd2Lower);
 

        if (!acc[key]) acc[key] = [];
        acc[key].push(cleanItem);        
        return acc;
    }, {});

    const buildChartOptions = (title, chartData) => {        
        const fullData = chartData.map((d) => ({
            // Spread the base item to retain all original fields
            ...d,

            // 1. Explicitly ensure date is converted and retained
            createdAt: d.createdAt.toISOString(),

            // 2. ✅ CRITICAL: Explicitly retain the calculated fields
            value: d.value,
            target: d.target,
            sd1Upper: d.sd1Upper,
            sd1Lower: d.sd1Lower,
            sd2Upper: d.sd2Upper,
            sd2Lower: d.sd2Lower,
            isFail: d.isFail, // <-- THIS IS THE KEY FIELD FOR THE RED MARKER
        }));        
        return {
            title: { text: title },
            data: fullData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)),
            axes: [
                {
                    type: "category",
                    position: "bottom",
                    title: { text: "Created At" },
                    label: {
                        rotation: 45,
                        formatter: ({ value }) =>
                            new Date(value).toLocaleDateString("en-US", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                            }),
                    },
                },
                { type: "number", position: "left", title: { text: "Measured Value" } },
            ],
            series: [
                {
                    type: "line",
                    xKey: "createdAt",
                    yKey: "value",
                    yName: "Measured Value",
                    xName: 'isFail',
                    stroke: "#2980B9",
                    strokeWidth: 2,                    
                    marker: {
                        enabled: true,
                        size: 6,
                        formatter: ({ datum }) => {

                            // Check for isFail directly, or check for it if the data is nested 
                            // within a 'data' property (a common pattern in charting libs).
                            const failed = datum.isFail || (datum.data && datum.data.isFail);                            

                            return ({
                                // Set fill color based on the determined 'failed' status
                                fill: failed ? "red" : "#2980B9",
                                stroke: "black",
                                strokeWidth: 1,
                            });
                        },
                    },
                    // ... (inside buildChartOptions, within the baseSeries definition)

                    tooltip: {
                        renderer: ({ datum }) => {
                            
                            const getTooltipContent = (data) => {
                                const valueDisplay = data.value === null || data.value === undefined ? "N/A" : data.value.toFixed(2);

                                return `
                            Value: ${valueDisplay}<br/>       
                        `;
                            };

                            return {
                                title: new Date(datum.createdAt).toLocaleString(),
                                content: getTooltipContent(datum),
                            };
                        },
                    },
                },
                // ... (rest of baseSeries and buildChartOptions)
                { type: "line", xKey: "createdAt", yKey: "target", yName: "Target (Mean)", stroke: "green", lineDash: [4, 4] },
                { type: "line", xKey: "createdAt", yKey: "sd1Upper", yName: "+1 SD", stroke: "orange", lineDash: [3, 3] },
                { type: "line", xKey: "createdAt", yKey: "sd1Lower", yName: "-1 SD", stroke: "orange", lineDash: [3, 3] },
                { type: "line", xKey: "createdAt", yKey: "sd2Upper", yName: "+2 SD", stroke: "red", lineDash: [3, 3] },
                { type: "line", xKey: "createdAt", yKey: "sd2Lower", yName: "-2 SD", stroke: "red", lineDash: [3, 3] },
            ],
            legend: { enabled: true },
        };
    };

    // ✅ Display mode logic
    switch (displayMode) {
        case "onePerLot":
            return (
                <div>
                    {Object.keys(groupedData).map((key) => {
                        const [lot, control] = key.split("__");
                        return (
                            <div key={key} style={{ height: "500px", marginBottom: "40px" }}>
                                <AgChartsReact
                                    options={buildChartOptions(
                                        `${lot} (${control})`,
                                        groupedData[key]
                                    )}
                                />
                            </div>
                        );
                    })}
                </div>
            );

        case "allLotsCombined": {
            const allData = Object.values(groupedData).flat();
            return (
                <div style={{ height: "500px" }}>
                    <AgChartsReact
                        options={buildChartOptions(
                            "All Lots Combined",
                            allData
                        )}
                    />
                </div>
            );
        }

        case "compareLots": {
            const allSeries = Object.keys(groupedData).map((key) => {
                const [lot, control] = key.split("__");
                return {
                    type: "line",
                    data: groupedData[key],
                    xKey: "createdAt",
                    yKey: "value",
                    yName: `Lot ${lot} (${control})`,
                    strokeWidth: 2,
                    marker: { enabled: true, size: 5 },
                };
            });

            const compareOptions = {
                title: { text: "Compare Lots & Controls" },
                axes: [
                    { type: "category", position: "bottom", title: { text: "Created At" } },
                    { type: "number", position: "left", title: { text: "Measured Value" } },
                ],
                series: allSeries,
                legend: { enabled: true },
            };

            return (
                <div style={{ height: "500px" }}>
                    <AgChartsReact options={compareOptions} />
                </div>
            );
        }

        default:
            return null;
    }
};

    renderChartView = () => {
        const { displayMode, chartData } = this.state;

        if (chartData.length === 0) {
            return (
                <div className="text-center py-4">
                    <p>No data available. Please apply filters to load chart data.</p>
                </div>
            );
        }

        const chartOptions = this.getChartOptions();

        return (
            <div className="chart-container">
                {displayMode === 'onePerLot' ? (
                    // Render multiple charts (one per lot)
                    <div>
                        {chartOptions &&
                            chartOptions.map((options, index) => (
                                <div key={index} className="mb-4" style={{ height: '400px' }}>
                                    <div>
                                        <strong>
                                            {this.state.analyte.name} - {this.getControlTypes(options)}
                                        </strong>
                                    </div>
                                    <div>
                                        <small className="text-muted">{this.getChartSubTitle(options)}</small>
                                    </div>
                                    <AgChartsReact options={options} />
                                </div>
                            ))}
                    </div>
                ) : (
                    // Render single chart (allLotsCombined or compareLots)
                    <div style={{ height: '500px' }}>{chartOptions && <AgChartsReact options={chartOptions} />}</div>
                )}

                <div className="mt-3">
                    <small className="text-muted">Total data points: {chartData.length}</small>
                </div>
            </div>
        );
    };

    getDisplayModeLabel = () => {
        const { displayMode } = this.state;
        switch (displayMode) {
            case 'onePerLot':
                return 'One Chart per Lot';
            case 'allLotsCombined':
                return 'All Lots Combined';
            case 'compareLots':
                return 'Compare Lots Side-by-Side';
            default:
                return '';
        }
    };

    renderGridView = () => {
        const { gridData, displayMode } = this.state;
        if (gridData.length === 0) {
            return (
                <div className="text-center py-4">
                    <p>No data available. Please apply filters to load grid data.</p>
                </div>
            );
        }

        // Group data by lot for onePerLot display mode
        if (displayMode === 'onePerLot') {
            const preparedData = this.prepareChartData();
            return (
                <div className="grid-container">
                    {Object.keys(preparedData).map((lotNumber) => (
                        <div key={lotNumber} className="mb-4">
                            <div className="table-responsive">
                                <table className="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th>Sample</th>
                                            <th>Analyte</th>
                                            <th>Control Type</th>
                                            <th>Lot Number</th>
                                            <th>Date/Time</th>
                                            <th>Value</th>
                                            <th>Instrument</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {preparedData[lotNumber].map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.qc_sample_id?.name || 'N/A'}</td>
                                                <td>{item.analyte_id?.name || 'N/A'}</td>
                                                <td>{item.qc_sample_id?.controlType || 'N/A'}</td>
                                                <td>{item.qc_sample_id?.lotNumber || 'N/A'}</td>
                                                <td>{item.createdAtFormatted}</td>
                                                <td>{item.value}</td>
                                                <td>{item.instrument_id?.name || 'N/A'}</td>
                                                <td>{item?.comment || 'N/A'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        // Default grid view for allLotsCombined and compareLots
        return (
            <div className="grid-container">
                <h5>Grid View - {this.getDisplayModeLabel()}</h5>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Sample ID</th>
                                <th>Analyte</th>
                                <th>Control Type</th>
                                <th>Lot Number</th>
                                <th>Date/Time</th>
                                <th>Value</th>
                                <th>Instrument</th>
                                <th>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gridData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.qc_sample_id?._id || 'N/A'}</td>
                                    <td>{item.analyte_id?.name || 'N/A'}</td>
                                    <td>{item.qc_sample_id?.controlType || 'N/A'}</td>
                                    <td>{item.qc_sample_id?.lotNumber || 'N/A'}</td>
                                    <td>{moment(item.createdAt).format('MM/DD/YYYY HH:mm')}</td>
                                    <td>{item.value}</td>
                                    <td>{item.instrument_id?.name || 'N/A'}</td>
                                    <td>{item?.comment || 'N/A'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="mt-3">
                    <small className="text-muted">Total records: {gridData.length}</small>
                </div>
            </div>
        );
    };

    renderSplitView = () => {
        const { displayMode, chartData } = this.state;

        if (chartData.length === 0) {
            return (
                <div className="text-center py-4">
                    <p>No data available. Please apply filters to load data.</p>
                </div>
            );
        }

        return (
            <div className="split-view-container">
                {/* Chart Section */}
                <div className="mb-5">
                    <h6 className="mb-3 text-primary">Chart View</h6>
                    {this.renderLeveyJenningsChart()}
                </div>

                {/* Grid Section */}
                <div className="mb-5">
                    <h6 className="mb-3 text-primary">Grid View</h6>
                    {this.renderGridView()}
                </div>
            </div>
        );
    };

    renderSaveReportModal = () => {
        return (
            <Modal show={this.state.showSaveModal} onHide={this.handleCloseSaveModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Save Report</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Report Name <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter report name"
                                value={this.state.reportName}
                                onChange={this.handleReportNameChange}
                                autoFocus
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseSaveModal}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={this.handleConfirmSaveReport}
                        disabled={!this.state.reportName.trim()}
                    >
                        Save Report
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        return (
            <div className="qc-report-details-container">
                <style jsx>{`
                    .page-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 30px;
                        padding-bottom: 15px;
                        border-bottom: 2px solid #e9ecef;
                    }

                    .page-title {
                        margin: 0;
                        color: #2c3e50;
                        font-weight: 600;
                        font-size: 16px;
                    }

                    .header-buttons {
                        display: flex;
                        gap: 10px;
                    }

                    .header-btn {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        padding: 8px 16px;
                        font-size: 14px;
                        font-weight: 500;
                        border-radius: 4px;
                        transition: all 0.2s ease;
                    }

                    .btn-save {
                        background: #28a745;
                        border: 1px solid #28a745;
                        color: white;
                    }

                    .btn-save:hover {
                        background: #218838;
                        border-color: #1e7e34;
                        color: white;
                    }

                    .btn-print {
                        background: #6c757d;
                        border: 1px solid #6c757d;
                        color: white;
                    }

                    .btn-print:hover {
                        background: #5a6268;
                        border-color: #545b62;
                        color: white;
                    }

                    .custom-tabs-wrapper {
                        border-bottom: 2px solid #e9ecef;
                        margin-bottom: 20px;
                    }

                    .custom-tabs .nav-link {
                        background: transparent;
                        border: none;
                        border-bottom: 3px solid transparent;
                        color: #6c757d;
                        font-weight: 500;
                        padding: 12px 16px;
                        margin: 0 8px 0 0;
                        transition: all 0.2s ease;
                        border-radius: 0;
                    }

                    .custom-tabs .nav-link:hover {
                        background: #f8f9fa;
                        color: #495057;
                        border-bottom-color: #dee2e6;
                    }

                    .custom-tabs .nav-link.active {
                        background: transparent;
                        color: #007bff;
                        border-bottom-color: #007bff;
                        font-weight: 600;
                    }

                    .tab-title {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        gap: 8px;
                    }

                    .tab-content-wrapper {
                        background: white;
                        padding: 20px 0;
                    }

                    .chart-grid-section h4 {
                        color: #2c3e50;
                        font-weight: 600;
                    }

                    .badge.bg-info {
                        background: #17a2b8 !important;
                        font-size: 11px;
                        padding: 4px 8px;
                        border-radius: 4px;
                    }

                    @media (max-width: 768px) {
                        .page-header {
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 15px;
                        }

                        .page-title {
                            font-size: 20px;
                        }

                        .header-buttons {
                            width: 100%;
                            justify-content: flex-end;
                        }

                        .custom-tabs .nav-link {
                            padding: 10px 12px;
                            font-size: 13px;
                            margin: 0 4px 0 0;
                        }

                        .tab-content-wrapper {
                            padding: 16px 0;
                        }
                    }
                `}</style>

                {/* Page Header with Title and Action Buttons */}
                <div className="page-header">
                    <h1 className="page-title">
                        {this.props.qcReportId
                            ? `${this.state.reportName} from ${moment(this.state.fromDate).format(
                                  'MM/DD/YYYY'
                              )} - ${moment(this.state.toDate).format('MM/DD/YYYY')}`
                            : 'New Report'}
                    </h1>
                    <div className="header-buttons">
                        <Button className="header-btn btn-save" onClick={this.handleSaveReport}>
                            <i className="fas fa-save"></i>
                            Save Current Report
                        </Button>
                        <Button className="header-btn btn-print" onClick={this.handlePrintReport}>
                            <i className="fas fa-print"></i>
                            Print
                        </Button>
                    </div>
                </div>

                {/* Recent QC Reports Section */}
                {this.renderRecentReports()}

                {/* Filters Section */}
                {this.renderFilters()}

                {/* Chart & Grid Section */}
                <div className="chart-grid-section">
                    {/* Simple Tabs */}
                    <div className="custom-tabs-wrapper">
                        <Tabs
                            activeKey={this.state.viewMode}
                            onSelect={(tab) => this.setState({ activeTab: tab, viewMode: tab })}
                            className="custom-tabs"
                        >
                            <Tab
                                eventKey="chart"
                                title={
                                    <span className="tab-title">
                                        <i className="fas fa-chart-line"></i>
                                        Chart View
                                    </span>
                                }
                            >
                                <div className="tab-content-wrapper">{this.renderLeveyJenningsChart()}</div>
                            </Tab>
                            <Tab
                                eventKey="grid"
                                title={
                                    <span className="tab-title">
                                        <i className="fas fa-table"></i>
                                        Grid View
                                    </span>
                                }
                            >
                                <div className="tab-content-wrapper">{this.renderGridView()}</div>
                            </Tab>
                            <Tab
                                eventKey="split"
                                title={
                                    <span className="tab-title">
                                        <i className="fas fa-columns"></i>
                                        Split View
                                    </span>
                                }
                            >
                                <div className="tab-content-wrapper">{this.renderSplitView()}</div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>

                {/* Save Report Modal */}
                {this.renderSaveReportModal()}
            </div>
        );
    }
}
